import { Component, input } from '@angular/core';

/**
 * The logo, title and subtitle that open every page in the auth shell.
 * Both texts come translated. Extra lead-in content (e.g. a code's
 * address) can follow as projected content.
 */
@Component({
  selector: 'app-auth-header',
  templateUrl: './auth-header.component.html',
  host: { class: 'flex flex-col' },
})
export class AuthHeaderComponent {
  readonly title = input.required<string>();

  readonly subtitle = input<string>();
}
